/* angular:styles/component:css;d32ffc1c866f85d823b65210dd29b315ee2c180b86db4fbf28a328882d880f18;/src/src/app/shared/components/formly/formly-field-navigation/formly-field-navigation.ts */
::ng-deep formly-form {
  height: 100% !important;
}
.custom-title {
  color: var(--ion-text-color);
  font-size: 1.25rem;
  font-weight: 500;
}
/*# sourceMappingURL=formly-field-navigation.css.map */
